import { Accordion, Group, Text } from '@mantine/core';
import { Clock } from 'react-feather';
import { TimeSlotSection } from '../TimeSlotSection';
import type { SectionRegister } from './sectionContract';

interface TimeSlotOptionsSectionProps {
  cohortId: string;
  cohortCode: string | null;
  registerSection?: SectionRegister;
}

export function TimeSlotOptionsSection({
  cohortId,
  cohortCode,
  registerSection,
}: TimeSlotOptionsSectionProps) {
  return (
    <Accordion.Item value="time-slots">
      <Accordion.Control>
        <Group gap="xs">
          <Clock size={18} />
          <Text fw={600}>Session Time Slot Options</Text>
        </Group>
      </Accordion.Control>
      <Accordion.Panel>
        <TimeSlotSection
          cohortId={cohortId}
          cohortCode={cohortCode}
          isCollapsible={false}
          registerSection={registerSection}
        />
      </Accordion.Panel>
    </Accordion.Item>
  );
}
